import type { SimulationState } from '../game/types'
import { createMinimapModel } from './minimap-model'

interface MinimapProps {
  state: SimulationState
}

const WIDTH = 200
const HEIGHT = 140

export function Minimap({ state }: MinimapProps) {
  const model = createMinimapModel(state, WIDTH, HEIGHT)
  if (!model) return null
  const points = model.trackPoints.map((point) => `${point.x.toFixed(2)},${point.y.toFixed(2)}`).join(' ')
  return (
    <svg className="minimap" viewBox={`0 0 ${WIDTH} ${HEIGHT}`} role="img" aria-label="Circuit minimap">
      <polyline className="minimap__road" points={points} />
      <polyline className="minimap__line" points={points} />
      <rect className="minimap__start" x={model.start.x - 2} y={model.start.y - 2} width={4} height={4} />
      <circle className="minimap__checkpoint" cx={model.nextCheckpoint.x} cy={model.nextCheckpoint.y} r={3.3} />
      {model.markers.map((marker) =>
        marker.isPlayer ? (
          <polygon
            key={marker.id}
            data-racer-marker={marker.id}
            className="minimap__player"
            points="0,-6 -4.5,5 0,3 4.5,5"
            fill={marker.accent}
            transform={`translate(${marker.x} ${marker.y}) rotate(${(marker.heading * 180) / Math.PI})`}
          />
        ) : (
          <circle
            key={marker.id}
            data-racer-marker={marker.id}
            className="minimap__rival"
            cx={marker.x}
            cy={marker.y}
            r={2.5}
            fill={marker.accent}
          />
        ),
      )}
    </svg>
  )
}
